module.exports = __webpack_public_path__ + "static/fd-logo-761bbc5052b7153bbcd763eecaabe7c0.png";